import { ObjectMapper } from './ObjectMapper';

export class GraduationMapper {
    private static properties: Array<keyof GraduationApi> = ['id', 'name', 'labelList', 'measurePath'];

    static getGraduationFromData(graduationData: GraduationApi): Graduation {
        GraduationMapper.checkGraduationData(graduationData);
        const { id, name, labelList, measurePath, previewPath } = graduationData;

        const graduation: Graduation = {
            id: (id as string) || '',
            name: (name as string) || '',
            graduationPath: `${window.env.VITE_BACK_URL}/downloadSvg?filename=${measurePath}` || '',
            previewPath: `${window.env.VITE_BACK_URL}/downloadSvg?filename=${previewPath}` || ''
        };
        const translatedName: string | undefined = ObjectMapper.getTranslatedName(labelList);
        graduation.name = translatedName || graduation.name;

        return graduation;
    }

    private static checkGraduationData(graduationData: GraduationApi): void {
        this.properties.forEach((prop) => {
            if (graduationData[prop] == null) {
                console.error(`Property ${prop} is missing or undefined in this graduation: ${graduationData.id}`);
            }
        });
    }
}
